// Route Resources

// Login Routes
export const LoginRoute = '/'
export const LinkRoute = '/link'

// Password Routes
export const RecoverPasswordRoute = '/reset'
export const ResetPasswordRoute = `${RecoverPasswordRoute}/:token`
export const ResetPasswordNoTokenRoute = `${RecoverPasswordRoute}/password`
export const SetPasswordRoute = '/set/:token'

// Onboarding Routes
export const OnboardingBaseRoute = '/onboarding'
export const CreateOrgRoute = `${OnboardingBaseRoute}/create-org`
export const CreateUserRoute = `${OnboardingBaseRoute}/create-user/:token`

// Misc Routes
export const MobileRoute = `${OnboardingBaseRoute}/mobile`
export const RecoverUsernameRoute = '/recover-username'
export const UnassociatedRoute = '/unassociated'

// SSO Routes
export const SingleSignOnRoute = '/sso'
export const SingleSignOnLinkRoute = `${LinkRoute}/sso`

// Trial Expired Routes
export const TrialExpiredRoute = '/expired/:orgslug'
